import { announcements, setAuthorizationHeader } from '../../api';
import {
  DISMISS_ANNOUNCEMENT,
  FETCH_ANNOUNCEMENTS_FAILURE,
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
} from '../../constants/ActionTypes';
import storage from '../../storage';
import { getIsAnnouncementsFetching } from './getters';
import { errorHandler } from '../../helpers/error-handler';

export const fetchAnnouncements = () => async (dispatch, getState) => {
  try {
    if (getIsAnnouncementsFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    dispatch({
      type: FETCH_ANNOUNCEMENTS_REQUEST,
    });

    const data = await announcements.getAnnouncements();

    dispatch({
      type: FETCH_ANNOUNCEMENTS_SUCCESS,
      data,
    });

    return Promise.resolve();
  } catch (e) {
    const processedError = errorHandler(e);

    dispatch({
      type: FETCH_ANNOUNCEMENTS_FAILURE,
      data: processedError,
    });

    return Promise.reject(e);
  }
};

export const dismissAnnouncement = (id) => (dispatch) => {
  dispatch({
    type: DISMISS_ANNOUNCEMENT,
    id: id,
  });

  return Promise.resolve();
};
